module.exports = __webpack_public_path__ + "7c84a7321c734cde0b1f6b7472f99af1.svg";